import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74fc8aee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:flex md:items-center justify-center flex-wrap md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col items-center md:flex-row justify-between" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1))
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_9 = {
  key: 0,
  class: "fixed inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 text-lg" }, "Loading...", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "py-6" }
const _hoisted_14 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_15 = { class: "max-w-full overflow-x-auto" }

import { inject, onMounted, ref, computed, watch } from "vue";
import { AxiosInstance } from "axios";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { useRoute } from "vue-router";
import DataTable from "@/components/tools/DataTable.vue";
import stringify from "qs-stringify";
import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { formatNumber, translate } from "@/utils/tools";
import { SearchIcon } from "@heroicons/vue/solid";
import EventEdit from "../../components/dialogs/EventEdit.vue";
import EventCreateDialog from "../../components/dialogs/EventCreateDialog.vue";
import EventFilterDialog from "@/components/dialogs/EventFilterDialog.vue";
import { useStore } from "vuex";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Event',
  setup(__props) {

dayjs.extend(localizedFormat);

const axios = inject("$axios") as AxiosInstance;
const route = useRoute();
const store = useStore();
const dataRows: any = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref<boolean>(false);
const createEventModal = ref<boolean>(false);
const editEventModal = ref<boolean>(false);
const isActivate = ref(false);
const selectedRow = ref({});

const columns = ref([
  {
    label: translate("messages.event.imageUrl"),
    field: "imageUrl",
    isImage: true,
    format: () => "",
  },
  {
    label: translate("messages.event.name"),
    field: "name",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.type"),
    field: "type",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.startDate"),
    field: "startAt",
    class: () => "w-32 flex flex-wrap",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.endDate"),
    field: "endAt",
    class: () => "w-32 flex flex-wrap",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.event.resetHour"),
    field: "reset_hour",
    isSorted: false,
    sort: true,
  },
  // {
  //   label: translate("messages.event.active"),
  //   field: "is_active",
  //   class: (data: any) => {
  //     if (data.is_active) {
  //       return "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white";
  //     }
  //     return "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white";
  //   },
  // },
  {
    label: translate("messages.event.dateCreated"),
    field: "created_at",
    align: "left",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.created_at).locale("th").format("LLL"),
  },
  // {
  //   label: translate("messages.event.action"),
  //   field: "action",
  //   align: "center",
  //   isToggle: true,
  //   permission: "QUEST_EVENT.UPDATE_STATUS",
  //   function: async (data: any) => {
  //     await axios.post(
  //       `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/events/updateActive`,
  //       { id: data.id, is_active: !data.is_active },
  //       {
  //         headers: {
  //           "x-cm-operator-id": store.state.selectedOperator.operatorId,
  //         },
  //       }
  //     );
  //     await fetchPageData();
  //   },
  // },
  {
    label: "",
    field: "create_sub_event",
    isFunction: true,
    permission: "QUEST_EVENT.EDIT",
    class: () =>
      "cursor-pointer inline-flex border border-transparent rounded-md  bg-blue-500 hover:bg-blue-600 text-white bg-blue-500 hover:bg-blue-600 ",
    auxClick: (data: any) => window.open(`event/${data.id}`),
    function: (data: any) => router.push({ name: "Sub Event", params: { id: data.id } }),
  },
  {
    label: "",
    field: "",
    isEdit: store.state.user.permissions.includes("QUEST_EVENT.EDIT") ? true : false,
    sort: false,
  },
  {
    label: "",
    field: "delete_event",
    isFunction: true,
    permission: "QUEST_EVENT.DELETE",
    class: () =>
      "cursor-pointer inline-flex border border-transparent rounded-md  bg-red-500 hover:bg-red-600 text-white bg-red-500 hover:bg-red-600 ",
    auxClick: (data: any) => {},
    function: (data: any) => deleteEvent(data),
  },
]);
const pageConfig = ref({
  page: 1,
  dataLength: 0,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  sort: [["seq_num", "DESC"]],
});

const filterForm = ref({
  name: undefined,
  type: undefined,
});

const fetchPageData = async () => {
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { name, type } = filterForm.value;
  isLoaded.value = false;

  const payload = {
    page,
    name: search || name || null,
    type: type || null,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/events/list`;
  const { rows } = await axios
    .post(url, payload, {
      headers: {
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
      },
    })
    .then(({ data }) => data)
    .catch(err => {
      isLoaded.value = true;
    });
    

  const newArray = rows.map((obj: any) => {
    return {
      ...obj,
      startAt: getLocaleDate(obj.start_at),
      endAt: getLocaleDate(obj.end_at),
      start_at: dayjs(obj.start_at).format("YYYY-MM-DD"),
      end_at: dayjs(obj.end_at).format("YYYY-MM-DD"),
      imageUrl: obj.image_url,
      create_sub_event: "Quest",
      delete_event: "Delete",
    };
  });
  // console.log("data event : ", newArray);

  dataRows.value = newArray;
  pageConfig.value.dataLength = rows.length;
  // pageConfig.value.pageCount = Math.ceil(count / rowsPerPage);
  // pageConfig.value.count = count;

  pageConfig.value = {
    ...pageConfig.value,
  };

  selectedRow.value = {};

  /** update url to persist page config */
  window.history.replaceState({}, document.title, `?${stringify({ page, rowsPerPage })}`);
  isLoaded.value = true;
};

const deleteEvent = async (data: any) =>{
  if (confirm(`Are you sure you want to delete event this Name? (Name: ${data.name})`)) {
    try{
      await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/events/delete`,
        { id: data.id },
        {
          headers: {
            "x-cm-operator-id": store.state.selectedOperator.operatorId,
          },
        }
      );
      await fetchPageData();
    }catch(error){
      alert(error?.response?.data?.message);
    }
  }
};

const edit = (e: any) => {
  // console.log("edit : ",e)
  selectedRow.value = e;
  editEventModal.value = true;
};

const getLocaleDate = (date: any) => {
  return dayjs(date).locale("th").format("LL");
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);
  if (!columns.value[index].sort) {
    return;
  }

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  let formattedAttName;
  if (attName.toLocaleLowerCase() === "event name") formattedAttName = "name";
  if (attName.toLocaleLowerCase() === "type") formattedAttName = "type";
  if (attName.toLocaleLowerCase() === "start date") formattedAttName = "seq_num";
  if (attName.toLocaleLowerCase() === "end date") formattedAttName = "end_at";
  if (attName.toLocaleLowerCase() === "reset hour") formattedAttName = "reset_hour";
  if (attName.toLocaleLowerCase() === "date created") formattedAttName = "seq_num";

  sort[0] = [formattedAttName || attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];
  // console.log("sort[0] : ",sort[0])
  fetchPageData();
};

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed test deploy*/
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.event.event')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              type: "search",
              name: "search",
              placeholder: _ctx.$t('messages.event.search'),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchPageData()), ["enter"]))
            }, null, 40, _hoisted_7), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (advanceFilterModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-white mr-2",
            icon: ['far', 'filter'],
            transform: ""
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.event.advanceFilter")), 1)
        ]),
        (_unref(store).state.user.permissions.includes('QUEST_EVENT.CREATE'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (createEventModal.value = true)),
              class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            }, _toDisplayString(_ctx.$t("messages.event.createEvent")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (!isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            onEdit: edit,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"]),
          _createVNode(EventEdit, {
            show: editEventModal.value,
            "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((editEventModal).value = $event)),
            form: selectedRow.value,
            onEdited: _cache[6] || (_cache[6] = ($event: any) => (fetchPageData())),
            onClosed: _cache[7] || (_cache[7] = ($event: any) => (fetchPageData()))
          }, null, 8, ["show", "form"]),
          _createVNode(EventFilterDialog, {
            show: advanceFilterModal.value,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((advanceFilterModal).value = $event)),
            form: filterForm.value,
            "onUpdate:form": _cache[9] || (_cache[9] = ($event: any) => ((filterForm).value = $event)),
            onFilter: _cache[10] || (_cache[10] = ($event: any) => (fetchPageData()))
          }, null, 8, ["show", "form"]),
          _createVNode(EventCreateDialog, {
            show: createEventModal.value,
            "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((createEventModal).value = $event)),
            onCreated: _cache[12] || (_cache[12] = ($event: any) => (fetchPageData()))
          }, null, 8, ["show"])
        ])
      ])
    ])
  ], 64))
}
}

})